import { FC } from 'react';
import { CircleCheck } from 'lucide-react';
import { motion } from 'framer-motion';

interface Props {
  title: string;
  description: string;
}

const SuccessScreen: FC<Props> = ({ title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <motion.div
        className="mb-6 flex size-20 items-center justify-center rounded-full bg-emerald-100"
        initial={{ scale: 0.4, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 280, damping: 18, delay: 0.05 }}
      >
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 320, damping: 20, delay: 0.2 }}
        >
          <CircleCheck className="size-10 text-emerald-600" />
        </motion.div>
      </motion.div>

      <motion.h1
        className="text-2xl font-bold mb-2"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.25, 0.1, 0.25, 1], delay: 0.28 }}
      >
        {title}
      </motion.h1>

      <motion.p
        className="text-muted-foreground max-w-sm"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.25, 0.1, 0.25, 1], delay: 0.38 }}
      >
        {description}
      </motion.p>
    </div>
  );
};

export default SuccessScreen;
